/* eslint-disable react/jsx-no-bind */
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import MuiTable from '@material-ui/core/Table';
import DotmapsLoader from '@shared/dotmaps-loader';
import Body from './body';
import Head from './head';
import EmptyBody from './empty-body';
import './table.scss';

const useStyles = makeStyles({
  table: {
    minWidth: 650
  }
});

const Table = ({
  actions,
  actionsRenderer,
  checked, checkedProps, onToggleAll, onToggle,  // Checkbox props.
  columns,
  dataType,
  empty,
  loading,
  header,
  onRowClick,
  rows,
  search,
  stickyFirstColumn,
  style,
  subType
}) => {
  const classes = useStyles();
  return (
    <div styleName="table-container" style={style}>
      {header}
      {search && <div styleName="search-container">{search}</div>}
      <div styleName="table-scroll-container">
        <MuiTable stickyHeader className={classes.table} style={{ padding: search ? '0 1.5rem' : '0' }} aria-label={`${dataType || 'Data'} table`}>
          <Head
            columns={columns}
            checkedProps={checkedProps}
            dataType={dataType}
            onToggleAll={onToggleAll}
            stickyFirstColumn={stickyFirstColumn}
            subType={subType}
          />
          <Body
            actions={actions}
            actionsRenderer={actionsRenderer}
            checked={checked}
            columns={columns}
            loading={loading}
            onToggle={onToggle}
            onRowClick={onRowClick}
            rows={rows}
            stickyFirstColumn={stickyFirstColumn}
          />
        </MuiTable>
      </div>
      {loading && (!rows || rows.length === 0) && <DotmapsLoader />}
      {!loading && rows.length === 0 && <EmptyBody {...empty} />}
    </div>
  );
};

Table.propTypes = {
  actions: PropTypes.array,
  actionsRenderer: PropTypes.func,
  checked: PropTypes.array,
  checkedProps: PropTypes.object,
  columns: PropTypes.array,
  dataType: PropTypes.string,
  empty: PropTypes.object,
  header: PropTypes.node,
  loading: PropTypes.bool,
  onRowClick: PropTypes.func,
  onToggle: PropTypes.func,
  onToggleAll: PropTypes.func,
  rows: PropTypes.array,
  search: PropTypes.node,
  stickyFirstColumn: PropTypes.bool,
  style: PropTypes.object,
  subType: PropTypes.string
};

Table.defaultProps = {
  loading: false,
  style: {}
};

export default Table;
